import { call, put } from 'redux-saga/effects';

import * as fileRoutines from './routines/fileRoutines';
import { rsf, storageList } from '../globals/firebase';
export function* sendStringSaga({ filePath, imageURL }) {
    const task = rsf.storage.uploadString(filePath, imageURL, 'data_url');
    yield task;
    let res = yield call(rsf.storage.getDownloadURL, filePath);
    return res;
}
export function* sendFileSaga({ file, filePath }) {
    const task = rsf.storage.uploadFile(filePath, file);
    yield task;
    let res = yield call(rsf.storage.getDownloadURL, filePath);
    return res;
}

export async function identifyFileToRemoveFromStorage(current, ref) {
    //Look in storage path and see if file exists whose public path is the same as the current image
    let data = await storageList(ref);
    let files = await Promise.all(
        data.items.map(async item => {
            return { public: await item.getDownloadURL(), private: item.fullPath };
        }),
    );
    files = files.filter(file => file.public === current);
    if (files.length) {
        return files[0].private;
    } else {
        return null;
    }
}

export function* deleteFileFromStorageSaga(current, ref) {
    //Look in storage path and see if file exists whose public path is the same as the current image
    let file = yield call(identifyFileToRemoveFromStorage, current, ref);
    if (file) {
        try {
            yield call(rsf.storage.deleteFile, file);
            yield put(fileRoutines.deleteFile.success(file));
        } catch (error) {
            yield put(fileRoutines.deleteFile.failure(error));
        }
    }
}

export default function* rootFileSagaWatcher() {

}
